import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var htmlIframeSrc = "\n  <head>\n    <style type=\"text/css\">\n      iframe[class|='instagram'],\n      blockquote[class|='instagram'] {\n        /* fallback script for ios below */\n        min-width: 0 !important;\n        width: calc(100vw - 2px);\n      }\n\n      body {\n        margin: 0;\n        max-width: calc(100vw);\n        display: inline-block;\n        float: left;\n        width: 100%;\n        box-sizing: border-box;\n      }\n      body > iframe {\n        margin: 0 !important;\n        width: calc(100vw - 2px) !important;\n      }\n      body::before,\n      body::after {\n        content: '.';\n        height: 0;\n        margin: 0;\n        overflow: hidden;\n        visibility: hidden;\n        display: block;\n        clear: both;\n      }\n    </style>\n    <script>\n      (function fixInstagramWidth() {\n        // This is a fallback for the styles above. Because inline styles can't be overridden in ios.\n        var callback = function() {\n          try {\n            if (document.body.firstChild.className.indexOf('instagram') >= 0) {\n              document.body.firstChild.style.minWidth = '0';\n              document.body.firstChild.style.width = 'calc(100vw - 2px)';\n            }\n          } catch (e) {}\n        };\n\n        var observer = new MutationObserver(callback);\n\n        observer.observe(document, {\n          childList: true,\n          subtree: true,\n        });\n      })();\n\n      function initSendHeight(id) {\n        /**\n         * Handle image load by triggering a resize\n         */\n        function imageLoaded(event) {\n          if (!event || event.type !== 'load') {\n            return;\n          }\n\n          var img = event.srcElement;\n          // Remove image from loading stack\n          var imageIndex = images.indexOf(img);\n          if (imageIndex !== -1) {\n            images.splice(imageIndex, 1);\n          }\n\n          handleResize();\n        }\n\n        /**\n         * Add 'load' event listener and store reference to image\n         * @param {elm} img Image being loaded\n         */\n        var images = [];\n        function addImage(img) {\n          if (images.indexOf(img) === -1) {\n            img.addEventListener('load', imageLoaded);\n            images.push(img);\n          }\n        }\n\n        /**\n         * Filter out images in the DOM that haven't loaded yet and add listener\n         */\n        function addImageLoadListeners() {\n          var imgs = document.querySelectorAll('img');\n          for (var i = 0; i < imgs.length; i++) {\n            var image = imgs[i];\n            // Do nothing if image is already loaded\n            if (\n              image.nodeName === 'IMG' &&\n              image.src &&\n              image.complete === false &&\n              image.readyState !== 4\n            ) {\n              addImage(image);\n            }\n          }\n        }\n\n        function getHeight() {\n          var height = parseInt(document.body.offsetHeight, 10);\n          var styles = document.defaultView.getComputedStyle(document.body);\n          height += parseInt(styles.getPropertyValue('margin-bottom'), 10);\n          height += parseInt(styles.getPropertyValue('margin-top'), 10);\n          return height;\n        }\n\n        function handleResize() {\n          multipleDelayedSendHeight();\n        }\n\n        var timerId;\n        function multipleDelayedSendHeight() {\n          sendHeight();\n          clearTimeout(timerId);\n          let delay = 100;\n          timerId = setTimeout(function request() {\n            sendHeight();\n            delay *= 2;\n            if (delay < 20000) {\n              timerId = setTimeout(request, delay);\n            }\n          }, delay);\n        }\n\n        function sendHeight() {\n          var height = getHeight();\n          parent.postMessage({ type: 'htmlPlugin:heightResize', id: id, height: height }, '*');\n        }\n\n        function setupMutationObserver() {\n          var target = document.querySelector('body');\n          var observer = new MutationObserver(function(mutations) {\n            addImageLoadListeners();\n            handleResize();\n          });\n\n          var config = {\n            attributes: true,\n            childList: true,\n            characterData: true,\n            subtree: true,\n          };\n\n          observer.observe(target, config);\n        }\n\n        window.addEventListener('resize', handleResize); //this handles width change\n        setupMutationObserver();\n        handleResize();\n      }\n\n      window.addEventListener('message', function(event) {\n        if (event.data.type !== 'htmlPlugin:updateContent') {\n          return;\n        }\n\n        var content = [\n          '<!DOCTYPE html>',\n          '<html>',\n          '<head>' + document.head.innerHTML + '</head>',\n          '<body>' + event.data.content + '</body>',\n          '</html>',\n        ].join('');\n\n        document.open('text/html', 'replace');\n        document.write(content);\n        document.close();\n        initSendHeight(event.data.id);\n      });\n    </script>\n  </head>\n\n  <body></body>\n";

var styles = {"iframe":"D-FLw"};

function _createForOfIteratorHelperLoose$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$2) {
    for (var _iterator = _createForOfIteratorHelperLoose$2(__getOwnPropSymbols$2(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols$2) {
    for (var _iterator2 = _createForOfIteratorHelperLoose$2(__getOwnPropSymbols$2(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var Iframe = function Iframe(_a) {
  var _b = _a,
    iframeRef = _b.iframeRef,
    isViewer = _b.isViewer,
    otherProps = __objRest(_b, ["iframeRef", "isViewer"]);
  return /* @__PURE__ */React.createElement("iframe", __spreadValues$2({
    ref: iframeRef,
    className: styles.iframe,
    title: "remote content",
    style: {
      backgroundColor: "transparent"
    },
    allow: isViewer ? "fullscreen; autoplay" : "fullscreen",
    allowFullScreen: true
  }, otherProps));
};

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var isSSR = typeof window === "undefined";
var HtmlSrcPath = "/html/db9376e69cfa487ea0fa0b912ae51a4f_v1.html";
var IframeHtml = /*#__PURE__*/function (_Component) {
  _inheritsLoose(IframeHtml, _Component);
  function IframeHtml() {
    var _this;
    _this = _Component.apply(this, arguments) || this;
    __publicField(_assertThisInitialized(_this), "state", {
      shouldRender: false
    });
    __publicField(_assertThisInitialized(_this), "id", Math.random().toString(36).substr(2, 9));
    __publicField(_assertThisInitialized(_this), "updateIframeContent", function (content) {
      var _a;
      _this.shouldIgnoreLoad = true;
      (_a = _this.iframe) == null ? void 0 : _a.contentWindow.postMessage({
        type: "htmlPlugin:updateContent",
        id: _this.id,
        content: content
      }, "*");
    });
    __publicField(_assertThisInitialized(_this), "handleIframeMessage", function (_ref) {
      var data = _ref.data;
      var type = data.type,
        id = data.id,
        height = data.height;
      if (type === "htmlPlugin:heightResize" && id === _this.id) {
        _this.props.onHeightChange(height);
      }
    });
    __publicField(_assertThisInitialized(_this), "handleIframeLoad", function () {
      !_this.shouldIgnoreLoad && _this.updateIframeContent(_this.props.html);
    });
    return _this;
  }
  var _proto = IframeHtml.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      shouldRender: true
    });
    !isSSR && window.addEventListener("message", this.handleIframeMessage);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    !isSSR && window.removeEventListener("message", this.handleIframeMessage);
  };
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.html !== nextProps.html) {
      this.updateIframeContent(nextProps.html);
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      iframeSandboxDomain = _this$props.iframeSandboxDomain,
      isViewer = _this$props.isViewer;
    var iframeProps = {
      style: {
        backgroundColor: "transparent"
      },
      onLoad: this.handleIframeLoad,
      iframeRef: function iframeRef(iframe) {
        return _this2.iframe = iframe;
      },
      isViewer: isViewer
    };
    if (iframeSandboxDomain) {
      var strippedUrl = iframeSandboxDomain.replace(/\/$/, "");
      iframeProps.src = strippedUrl + HtmlSrcPath;
    } else {
      iframeProps.srcdoc = htmlIframeSrc;
    }
    return this.state.shouldRender ? /* @__PURE__ */React.createElement(Iframe, __spreadValues$1({}, iframeProps)) : null;
  };
  return IframeHtml;
}(Component);
IframeHtml.propTypes = {
  html: PropTypes.string.isRequired,
  onHeightChange: PropTypes.any,
  iframeSandboxDomain: PropTypes.string,
  isViewer: PropTypes.bool
};
var IframeHtml$1 = IframeHtml;

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var IframeUrl = function IframeUrl(props) {
  return /* @__PURE__ */React.createElement(Iframe, __spreadProps(__spreadValues({}, props), {
    sandbox: "allow-popups allow-presentation allow-forms allow-same-origin allow-scripts"
  }));
};

var htmlComponentStyles = {"htmlComponent":"_9lBLQ","htmlComponent_placeholder":"eVgIb"};

var htmlFixer = function htmlFixer(html, pageURL) {
  var isGoogleAds = html == null ? void 0 : html.includes("adsbygoogle");
  var isIncludePageUrl = html == null ? void 0 : html.includes("data-page-url=");
  if (pageURL && isGoogleAds && !isIncludePageUrl) {
    var updatedAd = "<ins class=\"adsbygoogle\"\n\tdata-page-url=\"" + pageURL + "\"";
    return html == null ? void 0 : html.replace(new RegExp('<ins class="adsbygoogle"', "g"), updatedAd);
  }
  return html;
};

export { IframeHtml$1 as I, htmlComponentStyles as a, IframeUrl as b, htmlFixer as h };

import 'wix-rich-content-plugin-html/dist/loadable/viewer/es/styles.viewer.min.global.css'